exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#webamp .mini-time {\n    display: block;\n    height: 6px;\n    width: 25px;\n}\n\n#webamp .mini-time.blinking .character:not(.background-character) {\n    animation: blink 2s step-start 1s infinite;\n    -webkit-animation: blink 2s step-start 1s infinite;\n}\n\n#webamp .mini-time .background-character {\n    z-index: 1;\n}\n\n#webamp .mini-time .character {\n    position: absolute;\n    top: 0;\n    z-index: 2;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /node_modules/css-loader!./css/mini-time.css
// module id = 207
// module chunks = 5